<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('tools') }} </h3>
    </div>

    <div class="card-component">
        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="50"
            [pageable]="true" [sortable]="true" [groupable]="true" [reorderable]="true" [resizable]="true"
            [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 230px;" (valueChange)="onFilter($event)">
                </kendo-textbox>
                <kendo-grid-spacer></kendo-grid-spacer>

                <kendo-label class="k-checkbox-label" text="Mostrar abatidas"></kendo-label>
                <input type="checkbox" [(ngModel)]="isChecked" (change)="checkValue()" kendoCheckBox />

                <button [hidden]="!canEdit()" kendoButton icon="add" [title]="customMsgService.translate('btnCriar')"
                    (click)="open()" themeColor="primary">

                </button>
                <button kendoButton type="button" [hidden]="!canCreate()"
                    [title]="customMsgService.translate('btnImportar')" (click)="upload()" icon="upload"
                    themeColor="warning">
                </button>
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

            <kendo-grid-column field="identificacao" [title]="customMsgService.translate('identificacao')"
                [width]="120">

            </kendo-grid-column>

            <kendo-grid-column field="nomeTipoFerramenta" [title]="customMsgService.translate('tooltype')"
                [width]="120">
            </kendo-grid-column>

            <kendo-grid-column field="marca" [title]="customMsgService.translate('toolsubtypes')" [width]="100">
            </kendo-grid-column>

            <kendo-grid-column field="avariaDescricao" [title]="customMsgService.translate('avaria')" [width]="120"
                [class]="{ 'text-center': true }" [resizable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [hidden]="dataItem.avariada" class="badge badge-success"> {{
                        dataItem.avariaDescricao }} </span>
                    <span [hidden]="!dataItem.avariada" class="badge badge-danger"> {{
                        dataItem.avariaDescricao }} </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="condicaoDescricao" [title]="customMsgService.translate('condicao')" [width]="100"
                [class]="{ 'text-center': true }" [resizable]="false">

                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [hidden]="dataItem.bloqueada" class="badge badge-success">
                        {{customMsgService.translate('ativa')}} </span>
                    <span [hidden]="!dataItem.bloqueada" class="badge badge-danger">
                        {{customMsgService.translate('bloqueada')}} </span>
                </ng-template>


            </kendo-grid-column>


            <kendo-grid-column field="estadoDescricao" [title]="customMsgService.translate('state')" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [hidden]="dataItem.estado !== 0" class="badge badge-warning">
                        {{customMsgService.translate('pendente')}} </span>
                    <span [hidden]="dataItem.estado !== 1" class="badge badge-success">
                        {{customMsgService.translate('depositada')}} </span>
                    <span [hidden]="dataItem.estado !== 2" class="badge badge-success">
                        {{customMsgService.translate('levantada')}} </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="cartaoUtilizadorNaPosse" [title]="customMsgService.translate('user')"
                [width]="120" [class]="{ 'text-center': true }" [resizable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{dataItem.nomeUtilizadorNaPosse}}">
                        {{dataItem.cartaoUtilizadorNaPosse}}
                    </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="numeroDeSerie" [title]="customMsgService.translate('numeroDeSerie')"
                [width]="120">
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="45" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="pencil" [title]="customMsgService.translate('btnEditar')"
                        (click)="openEdit(dataItem)" [primary]="true"></button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="" [width]="45" [hidden]="!canEdit()">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button kendoGridEditCommand icon="delete" [title]="customMsgService.translate('btnEliminar')"
                        (click)="delete(dataItem)" themeColor="error"></button>
                </ng-template>
            </kendo-grid-column>
            
            <kendo-grid-pdf fileName="{{customMsgService.translate('tools')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('tools') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>

                <kendo-grid-column field="identificacao" [title]="customMsgService.translate('identificacao')">

                </kendo-grid-column>

                <kendo-grid-column field="nomeTipoFerramenta" [title]="customMsgService.translate('tooltype')">
                </kendo-grid-column>

                <kendo-grid-column field="marca" [title]="customMsgService.translate('toolsubtypes')">
                </kendo-grid-column>

                <kendo-grid-column field="avariaDescricao" [title]="customMsgService.translate('avaria')"
                    [class]="{ 'text-center': true }" [resizable]="false">


                </kendo-grid-column>

                <kendo-grid-column field="condicaoDescricao" [title]="customMsgService.translate('condicao')"
                    [class]="{ 'text-center': true }" [resizable]="false">


                </kendo-grid-column>


                <kendo-grid-column field="estadoDescricao" [title]="customMsgService.translate('state')">

                </kendo-grid-column>

                <kendo-grid-column field="cartaoUtilizadorNaPosse" [title]="customMsgService.translate('user')"
                    [class]="{ 'text-center': true }" [resizable]="false">

                </kendo-grid-column>

            </kendo-grid-pdf>

            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('tools')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>